
import {  CONVERSATIONS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"
import notif from "@/utils/notify"

export const del = ({ commit }, id) => {
  
   
    const url = `${id}/${CONVERSATIONS_API}/${id}`
    commit(types.SET_SHOW_LOADING)
    let message = "Oups, l'opération a échouée"
    let toastType = "error";
    backend({ url, data: null, method: "DELETE" }).then(({ data }) => {
        commit(types.SET_ITEMS, data)
        commit(types.SET_IS_SUCCESS)
        message ="Super,l'opération a été effectuée";
        toastType = "success";
        commit(types.SET_MESSAGE, "Super,l'opération a été effectuée")
        commit(types.SET_CURRENT_ITEM, null)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
        commit(types.RESET)

        notif(message,toastType)

    })
}


export const resetData = ({ commit }) => {

    commit(types.RESET)
}



